import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { type ReactNode, forwardRef } from 'react';
import { Button } from '../Button/Button';
import { Icon, type IconProps } from '../ui/Icon';

interface SidebarItemProps {
  icon: IconProps['as'];
  children: ReactNode;
  href?: string;
  onClick?: () => void;
  className?: string;
}

const SidebarItem = forwardRef<HTMLButtonElement, SidebarItemProps>(
  ({ icon, children, href, onClick, className, ...props }, ref) => {
    const pathname = usePathname();
    if (href)
      return (
        <Link href={href}>
          <Button
            {...props}
            ref={ref}
            onClick={onClick}
            className={`${pathname === href ? 'bg-muted' : ''} ${className || ''}`}
            size="xs"
            variant="sidebar"
          >
            <Icon className="flex-shrink-0 text-muted-foreground2" as={icon} />
            {children}
          </Button>
        </Link>
      );

    return (
      <Button
        ref={ref}
        onClick={onClick}
        size="xs"
        variant="sidebar"
        className={className}
        {...props}
      >
        <Icon className="flex-shrink-0 text-muted-foreground2" as={icon} />
        {children}
      </Button>
    );
  },
);

export default SidebarItem;
